/**
 * Portal Manta · CatalogoTabInterno
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { DADOS } from '../../data/lotes-pr.js';
import { V, S, sigKey, LOTES_INFO, OBRAS_ROD } from '../../globals.js';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { executarPipeline } from '../agentes/executarPipeline.jsx';
import { AGENTES_CATALOG } from '../../data/agentes-catalog.js';
import { PIPELINES } from '../../data/pipelines.js';
import { AGENTES_CATEGORIAS, THl, TH, TD, TDl } from '../../app-globals.js';

const CatalogoTabInterno = memo(function CatalogoTabInterno_Inner(){
  const [pipelineExec, setPipelineExec] = useState(null);
  const [progresso, setProgresso] = useState([]);
  const [resultados, setResultados] = useState({});
  const [rodando, setRodando] = useState(false);
  const [loteAlvo, setLoteAlvo] = useState('3');

  const executar = async (pipelineId) => {
    setPipelineExec(pipelineId);
    setProgresso([]);
    setResultados({});
    setRodando(true);
    const lote = LOTES_INFO[loteAlvo] || {sig:loteAlvo, k:loteAlvo};
    const sig = sigKey(lote);
    const cf = CONSOL_FIN[sig]||{};
    const od = OBRAS_ROD[sig]||{};
    const ext = parseFloat((lote.extensao||DADOS[sig]?.extensao||'').replace(/[^\d,.]/g,'').replace(',','.'))||0;
    const ctx = {lote, sig, cf, od, ext};
    const out = await executarPipeline(pipelineId, ctx, (p) => {
      setProgresso(prev => {
        const idx = prev.findIndex(x=>x.agenteId===p.agenteId);
        if (idx>=0) { const novo=[...prev]; novo[idx]={...novo[idx],...p}; return novo; }
        return [...prev, p];
      });
    });
    setResultados(out);
    setRodando(false);
  };

  const corCat = (cat) => AGENTES_CATEGORIAS[cat]?.cor || '#6B7280';
  const corStatus = (s) => s==='ok'?V.gn:(s==='rodando'?V.bl:(s==='erro'?'#dc2626':(s==='pulado'?'#f59e0b':V.gr)));
  const iconStatus = (s) => s==='ok'?'✓':(s==='rodando'?'⏳':(s==='erro'?'✗':(s==='pulado'?'⊘':'○')));

  return(<div style={S.page}>
    <div style={S.h1}>🧠 Catálogo de Agentes IA · Manta</div>
    <div style={S.sub}>{Object.keys(AGENTES_CATALOG).length} agentes em {Object.keys(AGENTES_CATEGORIAS).length} categorias · {Object.keys(PIPELINES).length} pipelines pré-definidos</div>

    {/* PIPELINES · executores */}
    <div style={{...S.cardP,padding:14,marginBottom:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.br,textTransform:'uppercase',letterSpacing:.05,marginBottom:10}}>Pipelines · executar sequência</div>
      <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:12,padding:'8px 10px',background:V.g0,borderRadius:5}}>
        <span style={{fontSize:10,color:V.gr,fontWeight:700,letterSpacing:.05,textTransform:'uppercase'}}>Lote alvo</span>
        <select value={loteAlvo} onChange={e=>setLoteAlvo(e.target.value)} style={{fontSize:11,padding:'4px 8px',border:'1px solid '+V.b1,borderRadius:4,background:'#fff',cursor:'pointer'}}>
          <option value="3">L3 · BR-376</option>
          <option value="4">L4 · PR-323</option>
          <option value="5">L5 · BR-369</option>
        </select>
      </div>
      {Object.values(PIPELINES).map(p => (
        <div key={p.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',marginBottom:8,border:'1px solid '+V.b1,borderRadius:6,background:'#fff'}}>
          <div style={{flex:1}}>
            <div style={{fontSize:12,fontWeight:800,color:V.br}}>{p.nome}</div>
            <div style={{fontSize:10,color:V.gr,marginTop:2,marginBottom:6}}>{p.desc}</div>
            <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
              {p.agentes.map((aId,i) => {
                const a = AGENTES_CATALOG[aId];
                const ev = progresso.find(x=>x.agenteId===aId);
                return (
                  <span key={aId} style={{fontSize:9.5,padding:'2px 7px',background:ev?'#fff':V.g0,border:'1px solid '+(ev?corStatus(ev.status):V.b1),color:ev?corStatus(ev.status):V.gr,borderRadius:99,fontWeight:700}}>
                    {ev?iconStatus(ev.status):''} {a?.icone} {a?.nome}
                  </span>
                );
              })}
            </div>
          </div>
          <button onClick={()=>executar(p.id)} disabled={rodando} style={{padding:'8px 14px',fontSize:11,fontWeight:800,background:rodando?V.g1:V.bl,color:'#fff',border:'none',borderRadius:5,cursor:rodando?'wait':'pointer'}}>
            {rodando && pipelineExec===p.id ? '⏳ Rodando…' : '▶ Executar'}
          </button>
        </div>
      ))}
      {pipelineExec && progresso.length>0 && (
        <div style={{marginTop:14,padding:'12px 14px',background:V.g0,border:'1px solid '+V.g1,borderRadius:6}}>
          <div style={{fontSize:10,fontWeight:700,color:V.gr,letterSpacing:.05,textTransform:'uppercase',marginBottom:6}}>Resultados do pipeline · {PIPELINES[pipelineExec]?.nome}</div>
          {progresso.map((ev,i) => {
            const a = AGENTES_CATALOG[ev.agenteId];
            const out = resultados[ev.agenteId];
            return (
              <div key={i} style={{display:'flex',alignItems:'flex-start',gap:10,padding:'8px 10px',marginBottom:4,background:'#fff',borderRadius:4,borderLeft:'3px solid '+corStatus(ev.status)}}>
                <span style={{fontSize:14,color:corStatus(ev.status),flexShrink:0,lineHeight:1.2}}>{iconStatus(ev.status)}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:10.5,fontWeight:700,color:V.br}}>{a?.icone} {a?.nome} <span style={{color:corStatus(ev.status),fontWeight:600}}>· {ev.status}</span></div>
                  {out?.msg && <div style={{fontSize:10,color:V.gr,marginTop:2}}>{out.msg}</div>}
                  {out?.executive && <div style={{fontSize:10,color:V.br,marginTop:4,padding:'6px 8px',background:V.g0,borderRadius:3,lineHeight:1.5}}>{out.executive}</div>}
                  {out?.erro && <div style={{fontSize:10,color:'#dc2626',marginTop:2}}>{out.erro}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    {/* CATÁLOGO · todos os agentes */}
    <div style={{...S.cardP,padding:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.br,textTransform:'uppercase',letterSpacing:.05,marginBottom:10}}>Catálogo · {Object.keys(AGENTES_CATALOG).length} agentes</div>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
        <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
          <th style={{...THl,width:30}}></th>
          <th style={THl}>Nome</th>
          <th style={{...TH,width:90}}>Categoria</th>
          <th style={{...TH,width:70}}>Tipo</th>
          <th style={THl}>Descrição</th>
          <th style={{...TH,width:90}}>Status</th>
        </tr></thead>
        <tbody>
          {Object.values(AGENTES_CATALOG).map(a => (
            <tr key={a.id} style={S.trLine}>
              <td style={{...TD,fontSize:18}}>{a.icone}</td>
              <td style={TDl}><b style={{color:V.br}}>{a.nome}</b><br/><span style={{fontSize:9,color:V.gr,fontFamily:'ui-monospace,monospace'}}>{a.id}</span></td>
              <td style={{...TD}}>
                <span style={{padding:'2px 8px',background:corCat(a.categoria)+'22',color:corCat(a.categoria),borderRadius:99,fontSize:9.5,fontWeight:700,letterSpacing:.05,textTransform:'uppercase'}}>{AGENTES_CATEGORIAS[a.categoria]?.label}</span>
              </td>
              <td style={{...TD,fontSize:9.5,color:a.tipo==='local'?V.gn:V.bl,fontWeight:700,textTransform:'uppercase'}}>{a.tipo}</td>
              <td style={{...TDl,fontSize:10,color:V.gr,lineHeight:1.4}}>{a.desc}</td>
              <td style={{...TD,fontSize:9.5,fontWeight:700,color:a.status==='em-dev'?'#f59e0b':V.gn}}>{a.status==='em-dev'?'em dev':'pronto'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>);
});

export { CatalogoTabInterno };
export default CatalogoTabInterno;
